import { render, staticRenderFns } from "./PlannedLevelSpellsList.vue?vue&type=template&id=497d198e&scoped=true&"
import script from "./PlannedLevelSpellsList.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelSpellsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d198e",
  null
  
)

export default component.exports